import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _find from 'lodash/find';
import _get from 'lodash/get';
import { Coupon } from 'commons/models/coupon';
import { AppContext, getClonedData, EMPTY_OBJECT } from 'commons-ui';

import useService from '../../utils/useService';
import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';
import { FORM_FIELD_KEYS } from '../../utils/formConfig';
import { UserlistData } from '../../utils/constants';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestCreateCoupon, requestAddUserlist } = useService();

	const formDefaults = { validFrom: new Date().getTime(), validTill: new Date().getTime() };

	const cloneCoupon = (clonedData: { couponData: Coupon; userListData?: UserlistData }) => {
		setShowLoader(true);
		const { couponData, userListData } = clonedData;

		requestCreateCoupon(app.appName, { ...couponData, isDisabled: true }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(`Error: ${res?.data?.error || 'Error occured while cloning the coupon'}`, { type: 'error' });
					setShowLoader(false);
					return;
				}

				if (userListData) {
					requestAddUserlist(app.appName, userListData).then(
						(userlistRes) => {
							const error = _find(userlistRes, (item) => item.status !== 200 || !item.data.success);
							if (error) {
								showAlert(
									`Error: Coupon was successfully created. Error occured while adding userlist. Please edit the coupon to add the list again`,
									{ type: 'error' }
								);
							} else {
								showAlert('Record created');
							}
							setShowLoader(false);
							history.goBack();
						},
						() => {
							showAlert(
								`Error: Coupon was successfully created. Error occured while adding userlist. Please edit the coupon to add the list again`,
								{ type: 'error' }
							);
							setShowLoader(false);
							history.goBack();
						}
					);
				} else {
					showAlert('Record created');
					setShowLoader(false);
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		cloneCoupon(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: hydrateFormData(getClonedData(_get(location, ['state', 'rowData'], EMPTY_OBJECT), FORM_FIELD_KEYS, formDefaults)),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
